import React, { useEffect } from 'react';
import SignalsPresentational from './SignalsPresentational';
import './MySignals.scss';
import { useAuth } from '../../../commons/Auth';

const SignalsAdminCondos = ({
  profile,
  query,
  total,
  signals,
  signalTypes,
  onFilter,
  checkVatCode,
  onUpdateSignal,
  searchSignalmens,
  searchCondos,
  searchAdmins,
  handleFileListView,
  deleteFileConfirm,
}) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  return (
    <SignalsPresentational
      data={signals}
      signalTypes={signalTypes}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
      checkVatCode={checkVatCode}
      onUpdateSignal={onUpdateSignal}
      searchSignalmens={searchSignalmens}
      searchCondos={searchCondos}
      searchAdmins={searchAdmins}
      handleFileListView={handleFileListView}
      deleteFileConfirm={deleteFileConfirm}
    />
  );
};

export default SignalsAdminCondos;
